import { useState, useEffect, useCallback } from "react";

export function useViewportInfo() {
  const isWalletMedia = window.matchMedia(`(max-width: 1165px)`);
  const isMobileMedia = window.matchMedia(`(max-width: 991px)`);
  const isSmallMedia = window.matchMedia(`(max-width: 600px)`);

  const [height, setHeight] = useState(window.innerHeight);
  const [mobileView, setMobileView] = useState(isMobileMedia.matches);
  const [smallWalletView, setSmallWalletView] = useState(isWalletMedia.matches);
  const [smallAccountView, setSmallAccountView] = useState(isSmallMedia.matches);


  const update = useCallback(() => {
    setHeight(window.innerHeight);
    
    setMobileView(isMobileMedia.matches);
    setSmallWalletView(isWalletMedia.matches);
    setSmallAccountView(isSmallMedia.matches);
  }, [isMobileMedia, isWalletMedia, isSmallMedia]);

  useEffect(() => {
    window.addEventListener("resize", update);
    isMobileMedia.addEventListener("change", update);
    isWalletMedia.addEventListener("change", update);
    isSmallMedia.addEventListener("change", update);

    return () => {
      window.removeEventListener("resize", update);
      isMobileMedia.removeEventListener("change", update);
      isWalletMedia.removeEventListener("change", update);
      isSmallMedia.removeEventListener("change", update);
    };
  }, []);

  return { height, mobileView, smallWalletView, smallAccountView };
}
